import React from "react";

import { compose } from "redux";

import { connect } from "react-redux";

import {
  firestoreConnect,
  populate,
  isLoaded,
} from "react-redux-firebase";

import { get } from "lodash";

import { Link as RouterLink } from "react-router-dom";

import {
  Box,
  Grid,
  Typography,
  Avatar,
  CardActionArea,
} from "@material-ui/core";

import { withStyles } from "@material-ui/core/styles";

import { firestoreConstants } from "../../firebase";

import routes, { USER_ENTRIES } from "../../data/routes";

const MEDALS = [
  { label: "1st", color: "#B8860B", bg: "#FFFBEA", border: "#FFD700" },
  { label: "2nd", color: "#696969", bg: "#F5F5F5", border: "#C0C0C0" },
  { label: "3rd", color: "#8B4513", bg: "#FDF5EE", border: "#CD7F32" },
];

const styles = (theme) => ({
  avatar1st: {
    width: theme.spacing(9),
    height: theme.spacing(9),
    margin: "0 auto",
    marginBottom: theme.spacing(1),
  },
  avatarOther: {
    width: theme.spacing(7),
    height: theme.spacing(7),
    margin: "0 auto",
    marginBottom: theme.spacing(1),
  },
  medalBadge: {
    display: "inline-block",
    borderRadius: 12,
    padding: "2px 10px",
    marginBottom: theme.spacing(1),
    fontWeight: 700,
    fontSize: "0.75rem",
  },
  podiumItem: {
    textAlign: "center",
    padding: theme.spacing(2, 1),
    borderRadius: theme.spacing(1),
  },
});

function getDisplayName(dbUser) {
  if (!dbUser || typeof dbUser !== "object") return "—";
  const { firstName, lastName, uid, id } = dbUser;
  let name = firstName || "";
  if (lastName) name = name ? `${name} ${lastName}` : lastName;
  if (name.trim()) return name.trim();
  const fallback = uid || id;
  return fallback ? fallback.substring(0, 6) : "—";
}

function getTop3(season, userEntriesById) {
  const { standings, contestantData } = season;
  if (!standings) return [];

  let orderedIds;
  if (standings.withSeasonPredictions) {
    orderedIds = [...standings.withSeasonPredictions.overall]
      .sort((a, b) => a.rank - b.rank)
      .slice(0, 3)
      .map((e) => e.id);
  } else if (standings.finalOverall) {
    orderedIds = standings.finalOverall.slice(0, 3);
  } else {
    return [];
  }

  return orderedIds
    .map((id) => {
      const entry = userEntriesById[id];
      if (!entry || typeof entry.userId !== "object") return null;

      const topPickId =
        entry.rankings && entry.rankings.length > 0 ? entry.rankings[0] : null;
      const topPick =
        topPickId && contestantData ? contestantData.byId[topPickId] : null;

      return {
        id,
        ownerName: getDisplayName(entry.userId),
        points: get(entry, ["scoring", "overall"]) ?? 0,
        winnerName: topPick ? topPick.name : null,
        winnerImageName: topPick ? topPick.fullImageName : null,
      };
    })
    .filter(Boolean);
}

function StandingsPreview({ classes, season, baseUrl, userEntriesById }) {
  if (!isLoaded(userEntriesById)) return null;

  const top3 = getTop3(season, userEntriesById);

  if (top3.length === 0) return null;

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Top Finishers
      </Typography>
      <Grid container spacing={1}>
        {top3.map((entry, i) => {
          const medal = MEDALS[i];
          const entryUrl =
            baseUrl + routes[USER_ENTRIES].pathWithoutParam + entry.id;
          return (
            <Grid item xs={4} key={entry.id}>
              <CardActionArea
                component={RouterLink}
                to={entryUrl}
                className={classes.podiumItem}
              >
                <Box>
                  <span
                    className={classes.medalBadge}
                    style={{ color: medal.color, backgroundColor: medal.bg }}
                  >
                    {medal.label}
                  </span>
                </Box>
                <Avatar
                  src={
                    entry.winnerImageName
                      ? `/images/${entry.winnerImageName}`
                      : undefined
                  }
                  className={i === 0 ? classes.avatar1st : classes.avatarOther}
                  style={{ border: `3px solid ${medal.border}` }}
                />
                <Typography
                  variant={i === 0 ? "subtitle1" : "body2"}
                  noWrap
                  title={entry.ownerName}
                >
                  <strong>{entry.ownerName}</strong>
                </Typography>
                <Typography variant="body2" color="textSecondary" noWrap title={entry.winnerName}>
                  {entry.winnerName || "—"}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {entry.points} pts
                </Typography>
              </CardActionArea>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

function mapStateToProps(state, props) {
  const seasonId = props.season.id;
  return {
    userEntriesById: populate(
      state.firestore,
      `${seasonId}#userEntries`,
      firestoreConstants.populateUserIds
    ),
  };
}

function registerFirestoreListeners(props) {
  const seasonId = props.season.id;
  return [
    {
      collection: "seasons",
      doc: seasonId,
      subcollections: [{ collection: "user_entries" }],
      populates: firestoreConstants.populateUserIds,
      storeAs: `${seasonId}#userEntries`,
    },
  ];
}

export default compose(
  withStyles(styles),
  firestoreConnect(registerFirestoreListeners),
  connect(mapStateToProps)
)(StandingsPreview);